// import external dependencies

import "jquery"

// Import everything from autoload
import "./autoload/_foundation.js"
import postSlider from './modules/sliderPost';

const sliderPost = $('.slider-block');
jQuery(document).ready(() => {});
$(window).load(function () {
	if (sliderPost.length >= 1) {
		postSlider(sliderPost);
	}
});



// WEBPACK FOOTER //
// ./scripts/main.js